export const EcomCurrencies = {
    1: 'GEL',
    2: 'USD',
    3: 'GEL, USD',
    4: 'EUR',
    5: 'GEL, EUR',
    6: 'USD/EUR',
    7: 'GEL, USD, EUR'
}